import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import { MeshPhysicalMaterial } from 'three'

// const draco = new DRACOLoader()
// draco.setDecoderPath('/draco/')
// draco.setDecoderConfig({ type: 'wasm' })
// draco.preload()

const loader = new GLTFLoader()
// loader.setDRACOLoader(draco)

const constructCDNURL = (modelID) => {
  return `/assets/models/${modelID}.glb`
}

export function loadModel(modelId, setModel, onError, onDone) {
  loader.load(
    constructCDNURL(modelId),
    (gltf) => {
      gltf.scene.traverse((child) => {
        if (child.isMesh) {
          child.castShadow = true
          child.receiveShadow = true
          if (
            child.material &&
            !child.material.name.includes('rubber') &&
            !child.material.name.includes('metal') &&
            !child.material.name.includes('back_material')
          ) {
            child.material = new MeshPhysicalMaterial({
              name: child.material.name,
            })
          }
        }
      })

      setModel(gltf.scene)
      onDone && onDone(gltf.scene)
    },
    undefined, // progress callback, is er niet dus undefined
    (error) => {
      // error
      console.error('Error loading GLB file:', error)
      onError && onError(error)
    },
  )
}
